import {useDisclosure, VStack} from '@chakra-ui/react';
import {TitledSection} from 'components/layouts/aside-layout';
import {useCartContext} from 'components/providers';
import {OrderProduct, ProductDetailsModal} from 'components/shared';
import {useTranslation} from 'hooks';
import {FC, useState} from 'react';
import {ICartItem} from 'types';

interface Props {
  items: ICartItem[];
  onItemEdit: (cartItem: ICartItem) => void;
  onQuantityChange: (value: number, meta: {cartItemId: string}) => void;
  onItemDelete: (cartItemId: string) => void;
}

export const CartItemList: FC<Props> = ({items, onQuantityChange, onItemEdit, onItemDelete}) => {
  const {onOpen, isOpen, onClose} = useDisclosure();
  const {t} = useTranslation();
  const [selectedCartItem, setSelectedCartItem] = useState<ICartItem>();

  const {cartProvider} = useCartContext();

  const currency = t('CURRENCY');
  const handleOpenProductModal = (product: ICartItem) => {
    setSelectedCartItem(product);
    onOpen();
  };

  if (!items?.length) return null;

  return (
    <TitledSection>
      <VStack spacing={5} justifyContent="stretch">
        {items.map((item) => {
          return (
            <OrderProduct
              key={item.id}
              data={item}
              countable
              onQuantityChange={onQuantityChange}
              onItemClick={() => handleOpenProductModal(item)}
              onItemDelete={onItemDelete}
              currency={currency}
            />
          );
        })}
      </VStack>
      {isOpen && selectedCartItem && (
        <ProductDetailsModal
          isFromEdit
          isOpen={isOpen}
          onClose={onClose}
          product={selectedCartItem.product}
          selectedCartItem={selectedCartItem}
          onEdit={onItemEdit}
          t={t}
          providerSlug={cartProvider?.slug}
        />
      )}
    </TitledSection>
  );
};
